<script>
    import List from './shared/list.svelte';
    import user from '../../state/user';

    let items = [];
    $: items = $user?.recordings ?? [];
</script>

{#if $user}
    <List {items} />
{:else}
    <article class="message is-info">
        <div class="message-body">
            Pro přístup do této sekce se musíte přihlásit.
        </div>
    </article>
{/if}
